/* Filtro do topo do Outlet.

   Esconde item a item, não bloco a bloco: os chips de categoria atravessam os
   dois blocos, e o bloco só some quando fica sem nenhum card visível — assim o
   título "Uso profissional com até 41% OFF" nunca sobra sozinho.

   Sem requisição e sem recarregar: a página inteira já veio do servidor, e com
   uma dúzia de itens não há o que buscar. */
(function () {
  'use strict';

  var barra = document.querySelector('[data-out-filtro]');
  if (!barra) return;

  var chips = Array.prototype.slice.call(document.querySelectorAll('[data-out-filtro]'));
  var itens = Array.prototype.slice.call(document.querySelectorAll('[data-out-item]'));
  var blocos = Array.prototype.slice.call(document.querySelectorAll('[data-out-bloco]'));
  if (!itens.length) return;

  function casa(item, filtro) {
    if (filtro === 'todos') return true;
    var p = filtro.split(':');
    if (p[0] === 'grupo') return item.getAttribute('data-grupo') === p[1];
    if (p[0] === 'tipo') return item.getAttribute('data-tipo') === p[1];
    return true;
  }

  function aplicar(filtro) {
    itens.forEach(function (item) {
      item.hidden = !casa(item, filtro);
    });

    /* Bloco sem card visível sai de cena junto com o próprio título. */
    blocos.forEach(function (bloco) {
      var vivos = bloco.querySelectorAll('[data-out-item]:not([hidden])').length;
      bloco.hidden = vivos === 0;
    });

    chips.forEach(function (c) {
      c.setAttribute('aria-pressed', c.getAttribute('data-out-filtro') === filtro ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-out-filtro]');
    if (!chip) return;
    e.preventDefault();
    aplicar(chip.getAttribute('data-out-filtro'));
  });
})();